<template>
  <section
    class="section-disclaimer bg-white sm:bg-gray-1 pt-60 sm:pt-48 md:pt-60 z-20 relative"
  >
    <div class="container text-center mx-auto pt-40 sm:pt-28 lg:pt-10 sm:mt-16">
      <div
        class="w-full text-center font-light text-gray-4 text-sm px-4 pt-4 sm:pb-8"
      >
        <slot name="text" />
      </div>
    </div>
  </section>
</template>
